import Work1 from "../../assets/work1.jpg"
import Work2 from "../../assets/work2.jpg"
import Work3 from "../../assets/work3.jpg"
import Work4 from "../../assets/work4.jpg"
import Work5 from "../../assets/work5.jpg"


export const projectsData = [

    {
      id: 1,
      image: Work1,
      title: "Netflix clone", 
      category: "Frontend",
      description:" i build The Front-end fonctionnalite for this application",
      href:"https://incredible-chebakia-bf8687.netlify.app/",
      github:"https://github.com/zikou24/Netflix-clone"
      
    },

  



    {
      id: 2,
      image: Work2,
      title: "search for handyman from home",
      category: "Backend",
      description:" i build all the backend for this application with django",
      href:"https://deploysearch-for-handymen-production.up.railway.app/",
      github:"https://github.com/zikou24/Django-App-search-for-handyman-by-State-"

    },
    {
      id: 3,
      image: Work3,
      title: "E commerce Website",
      category: "FullStack",
      description:" i build this application with react js and djangorest",
      github:"https://github.com/zikou24/Ecommerce"
    },

    {
      id: 3,
      image: Work5,
      title: "E commerce Website for phone",
      category: "Backend",
      description:" i build full e-commerce website using django",
      href:"https://zaki123.pythonanywhere.com/",
      github:"https://github.com/zikou24/Phoneapp"
    },

    {
      id: 5,
      image: Work5,
      title: "Connect with devloper",
      category: "Backend",
      description:" i build all the backend  for this application with django",
      href:"https://web-production-249c1.up.railway.app/",
      github:"https://github.com/zikou24/search-for-devlopper-website"



    },

    {
      id: 6,
      image: Work4,
      title: "Restaurant app", 
      category: "Frontend",
      description:"this is front end restaurant app with tailwind framer motion and react js ",
      href:"https://resonant-pothos-157e14.netlify.app",
      github:"https://github.com/zikou24/Restaurant-app"
      
    },
    {
      id: 7,
      image: Work2,
      title: "Online Learning website", 
      category: "Frontend",
      description:"online Courses with tialwind css and react ",
      href:"https://dashing-douhua-c7111c.netlify.app",
      github:"https://github.com/zikou24/E-Learning-Website"
      
    },
  ];
  

export const projectsNav = [
    {
        name:"All",
    },
    {
        name:"Frontend",
    },
    {
        name:"Backend",
    },
    {
        name:"FullStack",
    },
    
]